<template>
  <div :class="['$attrs.class', 'tw-transition-all tw-text-white tw-border-4 tw-shadow-lg', {'tw-border-gray-400': props.billingAccount.accounttype == 'creditcard'}, {'tw-border-orange-medium tw-shadow-2xl': props.billingAccount.accounttype == 'creditcard' && selected}, {'tw-border-black tw-shadow-2xl': props.billingAccount.accounttype != 'creditcard' && selected}]">
    <div class="tw-relative" 
      @click="billingAccountSet">
        <img :src="cardImage" :class="['image tw-transition-all', {'tw-opacity-75': !selected} ]">
        <div class="tw-absolute tw-top-0 tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-items-center tw-justify-center" v-if="selected">
          <span :class="['fa fa-check tw-text-9xl tw-text-shadow-2xl', {'tw-text-orange-medium': props.billingAccount.accounttype == 'creditcard'}]"></span>
        </div>
        <div class="tw-absolute tw-bottom-10 tw-left-8 tw-z-10" v-if="props.billingAccount.accounttype == 'creditcard'">{{expStr}}</div>
        <div class="tw-absolute tw-bottom-4 tw-left-8 tw-z-10" v-if="props.billingAccount.accounttype == 'creditcard'">••••&nbsp;••••&nbsp;••••&nbsp;{{billingAccount.cardsuffix}}</div>
        <div class="tw-absolute tw-bottom-4 tw-right-8 tw-z-10" v-if="props.billingAccount.accounttype == 'creditcard'">
          
        </div>

        <div class="tw-rounded-t-2xl tw-bg-white tw-py-4 tw-px-8 tw-text-center tw-bottom-0 tw-mx-24 tw-absolute tw-text-black" v-if="props.billingAccount.accounttype != 'creditcard'">
          <div class="">••••&nbsp;••••&nbsp;••••&nbsp;{{billingAccount.cardsuffix}}</div>
        </div>
      </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted, computed } from 'vue'
  import type BillingAccount from '../../classes/BillingAccount'
  import type {PropType} from 'vue';

  const props = defineProps({
    billingAccount: {
      type: (Object as PropType<BillingAccount>),
      default: [],
    },
    selected: {
      type: Boolean,
      default: false,
    }
  });

  const expStr = computed(() => {
    if (props.billingAccount.expiration) {
      let exp = props.billingAccount.expiration;
      let arr = exp.split('-')

      return arr[1] + '/' + arr[0].slice(2,4);
    } else {
      return ''
    }
  })

  const cardImage = computed(() => {
    if (props.billingAccount.accounttype == "creditcard") {
      return "https://mypiada-assets.s3.amazonaws.com/static_assets/credit-card-back.jpg"
    } else {
      return "https://mypiada-assets.s3.amazonaws.com/static_assets/gift-card-back.png"
    }
  })

  const emit = defineEmits(['setBillingAccount'])

  const billingAccountSet = () => {
    emit('setBillingAccount', props.billingAccount)
  }
</script>
